const doctorGalleryImages = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/doctor/GalleryImages");
const doctorGalleryAudios = () =>
    import ( /* webpackChunkName: "General" */ "@/components/dashboard/doctor/ComingSoon");
const doctorGalleryVideos = () =>
    import ( /* webpackChunkName: "General" */ "@/components/dashboard/doctor/ComingSoon");
const doctorGalleryPDFs = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/doctor/GalleryPdf");

export default [{
        path: "images",
        name: "dashboard.doctor.gallery.images",
        component: doctorGalleryImages
    },
    {
        path: "audios",
        name: "dashboard.doctor.gallery.audios",
        component: doctorGalleryAudios
    },
    {
        path: "videos",
        name: "dashboard.doctor.gallery.videos",
        component: doctorGalleryVideos
    },
    {
        path: "pdf",
        name: "dashboard.doctor.gallery.pdfs",
        component: doctorGalleryPDFs
    }
];